import { Button, Col, Form, Input, Row, Select, Spin, Switch } from 'antd';
import { Option } from 'antd/es/mentions';
import React, { useContext, useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import axiosInstance from '../../../../../../../axios_instance';
import {
  IsAdminContext,
  NumberOfProjectsContext,
  UserProjectsDataContext,
} from '../../../../../../../context';
import { errorHandling } from '../../../../../../../utils/helper';
import { SelectStringInput } from '../../../../../select-input';
import styles from './styles.module.scss';

export interface ISkill {
  skill_id: number;
  skill_name: string;
  skill_type: {
    id: number;
    name: string;
  };
  skill_category: Array<{
    id: number;
    name: string;
  }>;
}

const StyledSelectStringInput = styled(SelectStringInput)`
  .ant-select-selector {
    background-color: #f6f7fc !important;
    border: none !important;
  }
  border-bottom: 1px solid #d5d5d5;
`;

const AddProject: React.FC<{ setAddNew: any; companyOptions: any }> = ({
  setAddNew,
  companyOptions,
}: {
  setAddNew: any;
  companyOptions: any;
}) => {
  const [ProjectValue, setProjectValue] = useState<number>();
  const { userProjectData, setUserProjectData } = useContext(
    UserProjectsDataContext
  );
  const [errorMessage, setErrorMessage] = useState<any>({});
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [skills, setSkills] = useState<ISkill[]>([]);
  const isAdmin = useContext(IsAdminContext);
  const [message, setMessage] = useState<string>();
  //This url query parameter will be available for admin user
  const { employeeId } = useParams();
  const { numberOfProjects, setNumberOfProjects } = useContext(
    NumberOfProjectsContext
  );
  const [showInResume, setShowInResume] = useState(true);

  const handleChangeResume = (value: any) => {
    setShowInResume(value);
  };

  const handleSave = (values: any) => {
    setIsSubmitted(true);
    values.show_in_resume = showInResume;

    let url = '';
    if (isAdmin === '1') {
      url = '/api/v1/admin/profile/projects';
      values.profile_id = employeeId;
    } else {
      url = '/api/v1/profile/projects';
    }

    if (values.technology && values.technology.length) {
      values.technology = values.technology.map((t: any) => JSON.parse(t));
    } else {
      values.technology = [];
    }

    axiosInstance
      .post(url, values)
      .then((response) => {
        const userProjects = response.data.projects.filter(
          (project: any) => project.status.id === 1
        );
        const orderedProjects = response.data.order && response.data.order.length > 0
          ? response.data.order
              .map((projectId: number) =>
                userProjects.find((userProject: any) => userProject.project_id === projectId)
              )
              .filter((item: any) => item !== undefined)
          : userProjects;
        setUserProjectData(orderedProjects);
        setAddNew(false);
        setNumberOfProjects(orderedProjects.length);
      })
      .catch((error) => {
        errorHandling(error, setErrorMessage);
      })
      .finally(() => {
        setIsSubmitted(false);
      });
  };

  useEffect(() => {
    if (
      userProjectData &&
      userProjectData.find((data: any) => data.project_id === ProjectValue)
    ) {
      setMessage('The Project already exists.');
    } else {
      setMessage('');
    }
  }, [ProjectValue]);

  useEffect(() => {
    let url = '';
    url = '/api/v1/skills';
    axiosInstance
      .get(url)
      .then((response) => {
        const coreSkills = response.data.skills.filter(
          (skill: ISkill) => skill.skill_type.name === 'core_skill'
        );
        setSkills(coreSkills);
      })
      .catch((error) => {
        setMessage("Something went wrong!Items couldn't be loaded!");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const skillOptions =
    skills &&
    skills.map((skill) => (
      <Option
        key={skill.skill_id.toString()}
        value={JSON.stringify({
          skill_id: skill.skill_id,
          skill_name: skill.skill_name,
        })}
      >
        {skill.skill_name}
      </Option>
    ));

  // const handleChangeText = (value: any, name: string) => {
  //   setFormData({
  //     ...formData,
  //     [name]: value,
  //   });
  // };

  return (
    <div>
      <Form onFinish={handleSave} scrollToFirstError>
        <Row gutter={4} className={styles.row}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px',
              position: 'absolute',
              bottom: '8px',
              right: '8px',
            }}
          >
            <Switch defaultChecked onChange={handleChangeResume} />
            <span>Show in resume</span>
          </div>
          <Col span={12}>
            <p>
              <span className={styles.title}>Project Name : </span>
              <Form.Item
                name="project_name"
                rules={[
                  { required: true, message: 'Please enter Project Name' },
                ]}
              >
                <Input placeholder="Enter Project Name" />
              </Form.Item>
            </p>
          </Col>
          <Col span={12}>
            <p>
              <span className={styles.title}>Technology : </span>
              <Form.Item name="technology">
                <Select mode="multiple" placeholder="Select Technology">
                  {skillOptions}
                </Select>
              </Form.Item>
            </p>
          </Col>
          <Col span={12} style={{ paddingBottom: '40px' }}>
            <p>
              <span className={styles.title}>Description : </span>
              <Form.Item
                name="description"
                rules={[
                  { required: false, message: 'Please enter Description' },
                ]}
              >
                <ReactQuill
                  theme="snow"
                  placeholder="Enter description"
                  style={{ height: '150px' }}
                  className={styles.inputTextArea}
                />
              </Form.Item>
            </p>
          </Col>

          <Col span={12}>
            <p>
              <span className={styles.title}>My Contribution : </span>
              <Form.Item name="contribution">
                <ReactQuill
                  theme="snow"
                  placeholder="Enter Contribution"
                  style={{ height: '150px' }}
                  className={styles.inputTextArea}
                />
              </Form.Item>
            </p>
          </Col>
          <Col span={12}>
            <p>
              <span className={styles.title}>Company : </span>
              <Form.Item name="company_name">
                <Select
                  placeholder="Select Company"
                  optionLabelProp="label"
                  options={companyOptions}
                />
              </Form.Item>
            </p>
          </Col>

          <Col span={12}>
            <Row gutter={[10, 10]}>
              <Col span={12}>
                <p>
                  <span className={styles.title}>Start Date : </span>
                  <Form.Item name="start_date">
                    <Input type="date" />
                  </Form.Item>
                </p>
              </Col>
              <Col span={12}>
                <p>
                  <span className={styles.title}>End Date : </span>
                  <Form.Item name="end_date">
                    <Input type="date" />
                  </Form.Item>
                </p>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          {isSubmitted ? <Spin /> : <></>}
          <Form.Item style={{ float: 'right', marginLeft: 'auto' }}>
            <Button
              className={styles['save-button']}
              type="primary"
              htmlType="submit"
              style={{ float: 'right', marginLeft: 'auto', marginRight: '0px' }}
              // disabled={
              //   !ProjectValue
              // }
            >
              Save
            </Button>
          </Form.Item>

          <Button
            className={styles['cancel-button']}
            style={{ marginRight: '0px' }}
            onClick={(e) => {
              setAddNew(false);
            }}
          >
            Cancel
          </Button>
        </Row>
      </Form>
    </div>
  );
};

export default AddProject;
